/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgOrgUnitBranchListPathOrgUnitId, OrgOrgUnitBranchListStatus200 } from "../types/OrgOrgUnitBranchList.ts";

function getOrgOrgUnitBranchListUrl(org_unit_id: OrgOrgUnitBranchListPathOrgUnitId) {
	const res = { method: "GET", url: `/api/org/org-unit/${org_unit_id}/branch/` as const };

	return res;
}

/**
 * {@link /api/org/org-unit/:org_unit_id/branch/}
 */
export async function orgOrgUnitBranchList(org_unit_id: OrgOrgUnitBranchListPathOrgUnitId, config: Partial<RequestConfig> & { client?: Client } = {}) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrgOrgUnitBranchListStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getOrgOrgUnitBranchListUrl(org_unit_id).url.toString(),
		...requestConfig,
	});

	return res.data;
}
